var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var FavoriteFilled24 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentcolor' : _b, _c = _a.height, height = _c === void 0 ? '24px' : _c, _d = _a.width, width = _d === void 0 ? '24px' : _d, rest = __rest(_a, ["color", "height", "width"]);
    var svgStyle = __assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" }, { fill: color });
    return (React.createElement("div", __assign({ style: __assign({ "position": "relative" }, { height: height, width: width }) }, rest),
        React.createElement("svg", { viewBox: "0 0 24 24", style: svgStyle },
            React.createElement("path", { d: "M20.543 5.167C19.78 4.127 18.608 3.5 16.998 3.5c-1.611 0-2.983.782-4.115 2.064-.336.381-.63.785-.883 1.19a8.992 8.992 0 00-.884-1.19C9.984 4.282 8.613 3.5 7.002 3.5c-1.61 0-2.78.628-3.545 1.667-.457.62-.679 1.24-.753 1.675-.01.001-.054.157-.096.373-.744 3.816 1.491 8.935 9.09 14.67l.302.228.301-.228c7.6-5.735 9.835-10.854 9.091-14.67a3.49 3.49 0 00-.104-.416c-.081-.433-.303-1.032-.745-1.632z" }))));
};
FavoriteFilled24.displayName = 'FavoriteFilled24';
export default FavoriteFilled24;
//# sourceMappingURL=favorite-filled-24.js.map